import React, { useEffect, useContext, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import Select from 'react-select';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import NumberFormat from 'react-number-format';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import Modal from 'modules/common/components/Modal';
import * as actions from '../action';
import * as c from '../constant';

function EditAdditionalItemsModal({
  updateData,
  getActualUseList,
  actualUseList,
  getList,
  floorAreaList,
  dataInfo,
  buildingId,
  history,
  getBuildingComponents,
  componentList,
  buvAmount,
  dataList,
  getSingleBuildingComponent,
  getSingleBuildingApplication,
  ordinanceRevisionId
}) {

  const setModal = useContext(ModalContext);

  const [items, setItem] = useState({
    item: [],
  });

  useEffect(() => {
    getActualUseList();
  }, []);

  useEffect(() => {
    getBuildingComponents({ ordinance_revision_id: ordinanceRevisionId });
  }, []);

  const floorAreaOptions = floorAreaList.map((x) => {
    return {
      value: x.attributes.floor,
      label: x.attributes.floor,
    };
  });

  useEffect(() => {
    if (!_.isEmpty(dataList)) {
      const newSetOfForm = dataList.map((item) => {
        const data = {
          floor: item?.floor ?? item?.attributes?.floor,
          rptax_actual_use_id:
            item?.rptax_actual_use_id ?? item?.attributes?.rptax_actual_use_id,
          rptax_building_component_id:
            item?.rptax_building_component_id ?? item?.attributes?.rptax_building_component_id,
          area:
            item?.area ?? item?.attributes?.area,
          rate:
            item?.rate ?? item?.attributes?.rate,
          is_add_area:
            item?.is_add_area ?? item?.attributes?.is_add_area,
          percent: _.get(item, 'included.buildingComponent.attributes.is_percent') || "",
          componentRate: _.get(item, 'included.buildingComponent.attributes.rate_1') || "",
          type: _.get(item, 'included.buildingComponent.attributes.type') || "",
          id: item.id,
        };
        return data
      });

      setItem({
        item: newSetOfForm,
      });
    }
    if (dataInfo.length === 0) {
      setItem({
        item: dataInfo || [],
      });
    }
  }, [dataInfo]);

  const handleAddItem = () => {
    setItem({
      item: (items.item || []).concat([
        {
          id: (_.get(items, `item.${items.item.length - 1}.id`) || 0) + 1,
          floor: 0,
          rptax_actual_use_id: '',
          rptax_building_component_id: '',
          area: 0,
          rate: 0,
          is_add_area: 0,
        },
      ]),
    });
  };

  const handleOnChangeSelect = (item, key) => (e) => {

    let newItem = '';

    if (key === 'rptax_building_component_id') {
      getSingleBuildingComponent(e.value, (data) => {
        setItem({
          item: (items.item || []).map(x =>
            x.id === item.id ?
              {
                ...x,
                [key]:
                  +_.get(data, 'data.id'),
                percent: _.get(data, 'data.attributes.is_percent'),
                componentRate: _.get(data, 'data.attributes.rate_1'),
                type: _.get(data, 'data.attributes.type')
              } : x
          ),
        })
      })
    } else {
      newItem = {
        item: (items.item || []).map(x =>
          x.id === item.id ? { ...x, [key]: e.value } : x
        ),
      };

      setItem(newItem);

    }

  };

  const handleRemoveItem = (item) => () => {
    const newItem = {
      item: (items.item || []).filter((x) => x.id !== item.id),
    };
    setItem(newItem);
  };

  const handleChange = (e, key, item) => {

    const val = e.target.checked ? 1 : 0;

    const newItem = {
      item: (items.item || []).map((x) =>
        x.id === item.id ? { ...x, [key]: val } : x
      ),
    };

    setItem(newItem);
  };

  const actualUseOptions = actualUseList.map((x) => {
    return {
      value: +x.id,
      label: x.attributes.name,
    };
  });

  const componentOptions = componentList.map((x) => {
    return {
      value: +x.id,
      label: x.attributes.name,
    };
  });

  const closeModal = (e) => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure you want to cancel updating additional item?',
      () => {
        setModal({ isOpen: false });
      },
      () => { },
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  const handleOnSubmit = (e) => {
    e.preventDefault();

    const args = {
      additional_items: items.item
    };

    updateData(buildingId, args, () => {
      setModal({ isOpen: false });
      getList(buildingId);
      getSingleBuildingApplication(buildingId);
      history.push(`/rpt/building/applications/${buildingId}`);
    });

    return false;
  };

  const onChangeDecimal = (item, key, amount, rateAmount) => {
    const newItem = {
      item: (items.item || []).map((x) =>
        x.id === item.id
          ? {
            ...x,
            [key]: amount,
            rate: rateAmount
          }
          : x
      ),
    };
    setItem(newItem);
  };

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="">
          <div className="row d-flex align-items-center mt-2">
            <div className="col py-3 ml-2">
              <span className="title-color">Additional Items</span>
            </div>
            <div className="col py-0 m-0 d-flex">
              <button
                type="button"
                onClick={handleAddItem}
                className="btn btn-primary cms-bg-color-primary cms-outline-primary font-weight-bold px-4 ml-auto mr-2"
              >
                <i className="fas fa-plus" /> Add Additional Items
              </button>
            </div>
          </div>
          <div className="mt-4 col-12 form-group">
            <table className="css-table table table-borderless table-sm table-striped table-hover">
              <thead className="table-header">
                <tr>
                  <td width="100">
                    <span className="font-weight-bold">Floor</span>
                  </td>
                  <td width="200">
                    <span className="font-weight-bold">Actual Use</span>
                  </td>
                  <td width="300">
                    <span className="font-weight-bold">Component</span>
                  </td>
                  <td width="50">
                    <span className="font-weight-bold">Area</span>
                  </td>
                  <td width="150">
                    <span className="font-weight-bold">Rate</span>
                  </td>
                  <td width="50">
                    <span className="font-weight-bold">Add Area to Building Core?</span>
                  </td>
                  <td width="50">
                    <span className="font-weight-bold">Action</span>
                  </td>
                </tr>
              </thead>
              <tbody className="p-3">
                {(items.item || []).map((item, i) => (
                  <tr key={+item.id}>
                    <td width="100">
                      <Select
                        value={
                          floorAreaOptions.find(
                            (x) => +x.value === +_.get(item, 'floor')
                          ) || ''
                        }
                        onChange={handleOnChangeSelect(item, 'floor')}
                        options={floorAreaOptions}
                        placeholder="Select Floor"
                        className="react-select-container"
                        classNamePrefix="react-select"
                      />
                    </td>
                    <td width="200">
                      <Select
                        value={
                          actualUseOptions.find(
                            (x) => x.value === _.get(item, 'rptax_actual_use_id')
                          ) || ''
                        }
                        onChange={handleOnChangeSelect(item, 'rptax_actual_use_id')}
                        options={actualUseOptions}
                        placeholder="Select Actual Use"
                        className="react-select-container"
                        classNamePrefix="react-select"
                      />
                    </td>
                    <td width="300">
                      <Select
                        value={
                          componentOptions.find(
                            (x) => x.value === _.get(item, 'rptax_building_component_id')
                          ) || ''
                        }
                        onChange={handleOnChangeSelect(item, 'rptax_building_component_id')}
                        options={componentOptions}
                        placeholder="Select Building Component"
                        className="react-select-container"
                        classNamePrefix="react-select"
                      />
                    </td>
                    <td width="150">
                      <NumberFormat
                        name="area"
                        id="area"
                        placeholder="_"
                        className="form-control text-uppercase form-input-record"
                        onValueChange={values => {
                          const { floatValue } = values;

                          let finalValue = 0;

                          if (item.percent === 1 && item.type === 'Adjustment Factor (AF)') {
                            finalValue = parseFloat((+item.componentRate / 100) * floatValue * +buvAmount)
                          }

                          else if (item.percent === 0 && item.type === 'Adjustment Factor (AF)') {
                            finalValue = parseFloat(floatValue * +item.componentRate)
                          }

                          else if (item.type === 'Adjustment Factor (AF)') {
                            finalValue = parseFloat(floatValue * +buvAmount)
                          }

                          else if (item.type === 'Construction Material (CM)') {
                            finalValue = parseFloat(floatValue * +item.componentRate)
                          }

                          else if (item.type === 'Additional Item (AI)') {
                            finalValue = parseFloat((+item.componentRate / 100) * floatValue * +buvAmount)
                          }

                          onChangeDecimal(item, 'area', floatValue, finalValue);
                        }}
                        allowNegative={false}
                        isNumericString
                        thousandSeparator
                        displayType="input"
                        prefix=""
                        value={_.get(item, 'area')}
                      />
                    </td>
                    <td width="150">
                      PHP{' '}
                      {_.get(item, 'rate')
                        ? parseFloat(
                          _.get(item, 'rate')
                        ).toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })
                        : '0.00'}
                    </td>
                    <td style={{ textAlign: 'center' }}>
                      <input
                        className='form-check-input mt-3'
                        type='checkbox'
                        checked={_.get(
                          item,
                          "is_add_area"
                        )}
                        name='is_add_area'
                        id='is_add_area'
                        onChange={(e) =>
                          handleChange(e, "is_add_area", item)
                        }
                      />
                    </td>
                    {i !== 0 && (
                      <td width="50">
                        <button
                          type="button"
                          className="btn-blank"
                          onClick={handleRemoveItem(item)}
                        >
                          <i className="far fa-trash-alt icon-delete" />
                        </button>
                      </td>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
            <hr className="below-hr" />
            <div className="d-flex justify-content-center mt-5">
              <button
                type="button"
                onClick={closeModal}
                className="btn btn-light button-cancel-2 mr-1"
                style={{ backgroundColor: '#323943', color: '#fff' }}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="btn btn-light button-proceed ml-1 cms-bg-color-primary"
                style={{ color: '#fff' }}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      </form>
    </Modal.Body>
  );
}

EditAdditionalItemsModal.defaultProps = {
  floorAreaList: [],
  buildingId: '',
  dataInfo: {},
  buvAmount: 0,
  dataList: [],
  ordinanceRevisionId: '',
};

EditAdditionalItemsModal.propTypes = {
  actualUseList: PropTypes.instanceOf(Array).isRequired,
  getActualUseList: PropTypes.instanceOf(Function).isRequired,
  componentList: PropTypes.instanceOf(Array).isRequired,
  getBuildingComponents: PropTypes.instanceOf(Function).isRequired,
  updateData: PropTypes.instanceOf(Function).isRequired,
  getList: PropTypes.instanceOf(Function).isRequired,
  getSingleBuildingApplication: PropTypes.instanceOf(Function).isRequired,
  floorAreaList: PropTypes.instanceOf(Array),
  buildingId: PropTypes.string,
  buvAmount: PropTypes.number,
  dataInfo: PropTypes.instanceOf(Object),
  history: PropTypes.instanceOf(Object).isRequired,
  dataList: PropTypes.instanceOf(Array),
  getSingleBuildingComponent: PropTypes.instanceOf(Function).isRequired,
  ordinanceRevisionId: PropTypes.string,
};

const mapStateToProps = ({ api }) => ({
  actualUseList: _.get(api, `${c.GET_ACTUAL_USE_LIST}.list`) || [],
  componentList: _.get(api, `${c.GET_BUILDING_COMPONENTS}.list`) || [],
});

const enhance = _.flowRight([
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(EditAdditionalItemsModal);